import { createContext, useContext, useState } from 'react'

interface Report {
    id: string
    title: string
    content: string
    createdAt: string
    updatedAt: string
    userId: string
    userName: string
}

interface ReportContextType {
    reports: Report[]
    setReports: (reports: Report[]) => void
    addReport: (report: Report) => void
    updateReport: (report: Report) => void
    deleteReport: (id: string) => void
}

const ReportContext = createContext<ReportContextType | undefined>(undefined)

export function ReportProvider({ children }: { children: React.ReactNode }) {
    const [reports, setReports] = useState<Report[]>([])

    const addReport = (report: Report) => {
        setReports((prev) => [...prev, report])
    }

    const updateReport = (report: Report) => {
        setReports((prev) =>
            prev.map((r) => (r.id === report.id ? report : r))
        )
    }

    const deleteReport = (id: string) => {
        setReports((prev) => prev.filter((r) => r.id !== id))
    }

    return (
        <ReportContext.Provider
            value={{
                reports,
                setReports,
                addReport,
                updateReport,
                deleteReport,
            }}
        >
            {children}
        </ReportContext.Provider>
    )
}

export function useReport() {
    const context = useContext(ReportContext)
    if (context === undefined) {
        throw new Error('useReport must be used within a ReportProvider')
    }
    return context
} 